// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'shipments.observacaoDialog.titleActive': 'Observação ativa',
    'shipments.observacaoDialog.titleAdd': 'Adicionar observação',
    'shipments.observacaoDialog.noText': 'Sem texto.',
    'shipments.observacaoDialog.openedBy': 'Aberta por {{name}}',
    'shipments.observacaoDialog.openedByAt': 'Aberta por {{name}} em {{date}}',
    'shipments.observacaoDialog.userFallback': 'usuário',
    'shipments.observacaoDialog.description':
      'O alerta destaca a linha em azul e mantém o Status viagem atual. Descreva o motivo abaixo.',
    'shipments.observacaoDialog.notesLabel': 'Observações',
    'shipments.observacaoDialog.wait': 'Aguarde…',
    'shipments.observacaoDialog.resolveAlert': 'Resolver alerta',
    'shipments.observacaoDialog.activateAlert': 'Ativar alerta',
  },
  en: {
    'shipments.observacaoDialog.titleActive': 'Active note',
    'shipments.observacaoDialog.titleAdd': 'Add note',
    'shipments.observacaoDialog.noText': 'No text.',
    'shipments.observacaoDialog.openedBy': 'Opened by {{name}}',
    'shipments.observacaoDialog.openedByAt': 'Opened by {{name}} on {{date}}',
    'shipments.observacaoDialog.userFallback': 'user',
    'shipments.observacaoDialog.description':
      'The note highlights the row in blue and keeps the current trip status. Describe the reason below.',
    'shipments.observacaoDialog.notesLabel': 'Notes',
    'shipments.observacaoDialog.wait': 'Please wait…',
    'shipments.observacaoDialog.resolveAlert': 'Resolve alert',
    'shipments.observacaoDialog.activateAlert': 'Activate alert',
  },
  es: {
    'shipments.observacaoDialog.titleActive': 'Observación activa',
    'shipments.observacaoDialog.titleAdd': 'Añadir observación',
    'shipments.observacaoDialog.noText': 'Sin texto.',
    'shipments.observacaoDialog.openedBy': 'Abierta por {{name}}',
    'shipments.observacaoDialog.openedByAt': 'Abierta por {{name}} el {{date}}',
    'shipments.observacaoDialog.userFallback': 'usuario',
    'shipments.observacaoDialog.description':
      'La alerta resalta la fila en azul y mantiene el estado del viaje actual. Describe el motivo abajo.',
    'shipments.observacaoDialog.notesLabel': 'Observaciones',
    'shipments.observacaoDialog.wait': 'Espere…',
    'shipments.observacaoDialog.resolveAlert': 'Resolver alerta',
    'shipments.observacaoDialog.activateAlert': 'Activar alerta',
  },
}
